import React from 'react';
import { View } from 'react-native';
import Text from 'design-system/Text';
import { rem, Spacer } from 'design-system';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const StockFinancialCardInfoBadge = ({ title, info }) => {
    const styles = useStyles(styleSet);
    return (<View style={styles.row}>
      <View style={styles.container}>
        <Text TextThin-14 Secondary>
          {title}
        </Text>
        <Spacer w={8}/>
        <Text Numbers-16>{info}</Text>
      </View>
    </View>);
};
export default StockFinancialCardInfoBadge;
const styleSet = createStyleSheets((colors) => ({
    row: {
        flexDirection: 'row',
    },
    container: {
        alignItems: 'center',
        borderRadius: rem(8),
        flexDirection: 'row',
        paddingVertical: rem(8),
        paddingHorizontal: rem(16),
        backgroundColor: colors.background.dark,
    },
}));
